import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  allOrganizationNotice,
  createAndUpdateNoticeSection,
  createNoticeSrcImages,
  getAllNoticeSrcImages,
  organizationNoticeTemplate,
  previewNotice,
  saveNoticeSection,
  viewNotice,
} from "../../../api/noticeTemplate_api";

export const organizationNoticeSectionAction = createAsyncThunk(
  "notice/allOrganization",
  async (values, { rejectWithValue }) => {
    try {
      const result = await allOrganizationNotice(values);
      const { data, status } = result;

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to save section"
      );
    }
  }
);

export const organizationNoticeTemplateAction = createAsyncThunk(
  "notice/noticeTemplate",
  async (params, { rejectWithValue }) => {
    try {
      const result = await organizationNoticeTemplate(params);
      const { data, status } = result;

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to save section"
      );
    }
  }
);

export const saveNoticeSectionAction = createAsyncThunk(
  "notice/saveNoticeSection",
  async (values, { rejectWithValue }) => {
    try {
      const result = await saveNoticeSection(values);
      const { data, status } = result;

      return { data, status };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to save section"
      );
    }
  }
);

export const createAndUpdateNoticeSectionAction = createAsyncThunk(
  "notice/createAndUpdate",
  async (values, { rejectWithValue }) => {
    try {
      const result = await createAndUpdateNoticeSection(values);
      const { data, status } = result;

      return { data, status };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to save section"
      );
    }
  }
);

export const viewNoticeAction = createAsyncThunk(
  "notice/viewNotice",
  async (id, { rejectWithValue }) => {
    try {
      const response = await viewNotice(id);
   
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to save section"
      );
    }
  }
);

export const previewNoticeAction = createAsyncThunk(
  "notice/viewNotice",
  async (values, { rejectWithValue }) => {
    try {
      const response = await previewNotice(values);
    
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to save section"
      );
    }
  }
);

// noticeTemplatesActions.js
export const createNoticeSrcImagesAction = createAsyncThunk(
  "notice/createNoticeSrcImages",
  async (files, { rejectWithValue }) => {
    try {
      const formData = new FormData();
     
      files.forEach((file) => {
        formData.append("images", file); 
      });

      const response = await createNoticeSrcImages(formData);
      return response;
    } catch (error) {
      console.error("Upload error:", error);
      return rejectWithValue(
        error.response?.data?.error || error.response?.data?.message || "Failed to upload images"
      );
    }
  }
);


export const getAllNoticeSrcImagesAction = createAsyncThunk(
  "notice/getAllNoticeSrcImages",
  async (values, { rejectWithValue }) => {
    try {
      const response = await getAllNoticeSrcImages();
    
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to save section"
      );
    }
  }
);
